import React, { useMemo } from 'react'
import { IoMdClose } from 'react-icons/io'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { removeTitle } from 'store/checkout/titlesSlice'
import { RiVipCrownFill } from 'react-icons/ri'
import CartPlaceholder from './CartPlaceholder'

const SidePanelContent = React.memo(() => {
    const dispatch = useDispatch()

    const selectedTitles = useSelector(
        (state) => state.checkout.titles.selectedTitles,
        shallowEqual
    )

    const renderedTitles = useMemo(() => {
        return selectedTitles.map((title) => (
            <li
                key={title.id}
                className="flex items-center justify-between border-b py-3 px-5 last:border-b-0"
            >
                <div className="flex-initial w-60">
                    <div className="flex gap-3 items-center">
                        <img
                            className={`avatar-img avatar-square w-10 h-10 object-contain`}
                            src={title.logos.small}
                            loading="lazy"
                            alt={title.name}
                            onError={(e) => {
                                e.target.onerror = null // Prevent infinite loop in case fallback image is also broken
                                e.target.src = '/img/logo/logo-light-full.svg' // Set the fallback image source here
                            }}
                        />
                        <div className="flex flex-col gap-1 text-black">
                            <span className="font-medium">{title.name}</span>
                            <p className="text-sm text-gray-700">
                                {title.publisher.name}
                            </p>
                        </div>
                    </div>
                </div>

                {title.titleClassification.titleClassification === 'Premium' ? (
                    <div className="flex justify-start items-center">
                        <RiVipCrownFill className="text-lg text-orange-400" />
                        <span className="mx-2 font-semibold text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-500">
                            Premium
                        </span>
                    </div>
                ) : (
                    <span className="font-semibold text-cyan-500">
                        Standard
                    </span>
                )}

                <span
                    onClick={() => dispatch(removeTitle(title.id))}
                    className="cursor-pointer"
                >
                    <IoMdClose />
                </span>
            </li>
        ))
    }, [selectedTitles, dispatch])

    return (
        <div className="h-full flex pb-5">
            <div className="overflow-auto h-100 w-full">
                {selectedTitles.length > 0 ? (
                    <ul className="w-full">{renderedTitles}</ul>
                ) : (
                    <CartPlaceholder />
                )}
            </div>
        </div>
    )
})

export default SidePanelContent
